var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle-double-down (\xE5\x9C\x86\xE5\xBD\xA2\xE5\x8F\x8C\xE4\xB8\x8B\xE7\xAE\xAD\xE5\xA4\xB4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 15.5833C13.1421 15.5833 16.5 12.412 16.5 8.5C16.5 4.58798 13.1421 1.41667 9 1.41667C4.85786 1.41667 1.5 4.58798 1.5 8.5C1.5 12.412 4.85786 15.5833 9 15.5833Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.625 6.02083L9 8.5L6.375 6.02083",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.625 9.20833L9 11.6875L6.375 9.20833",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeta);
export default __webpack_public_path__ + "static/media/seta.9c759decdacbc80437ef010dbae53c5f.svg";
export { ForwardRef as ReactComponent };